module.exports = __webpack_public_path__ + "static/media/new-digha.3d8f2e4c.jpg";